const locale = {
  TITLE: "Welcome to CYPMS",
};

export default locale;
